export const validateOne = <T>(group: Array<T>) => (val: T) => group.includes(val);

export const validateEndsWith = (group: Array<string>) => (val: string) =>
    group.some((unit) => val.endsWith(unit));
